(
    function (skyward, $)
    {
        skyward = skyward || {};
        skyward.multipleselectbox = skyward.multipleselectbox || {};
        var init = function (selector)
        {
            $(selector + " .multipleSelectBox").on("click", function ()
            {
                var multiSelectBox = $(this);
                var multiSelectBoxData = multiSelectBox.data();
                var selectedOptions = multiSelectBox.find(".multipleSelectOptionCheckbox:checked:visible");
                var multiSelectHeader = multiSelectBox.find(".multipleSelectHeader");
                multiSelectHeader.text(selectedOptions.length > 0 ? multiSelectBoxData.headerTextSome : multiSelectBoxData.headerTextNone);

                var backingData = multiSelectBox.find(".multiSelectBackingData");
                var searchParameters = [];
                selectedOptions.each(function ()
                {
                    var selectedOption = $(this);
                    searchParameters.push(selectedOption.val());
                });
                updateHiddenField(backingData, searchParameters, true);
            });

            $(selector + " .addCustomValueButton").on("click", AddCustomClick);

            $(selector + " .customValue").on("change", removeCustomValue);
        };

        skyward.multipleselectbox.populate = function (backingData, value, triggerChange)
        {
            var multiSelectBox = backingData.closest(".multipleSelectBox");
            var options = multiSelectBox.find(".multipleSelectOptionCheckbox");

            var data = (typeof value != "object") ? JSON.parse(value) : (value ?? []);

            // data should always be an array, but keeping Object.keys for backwards compatibility
            var searchParameters = Array.isArray(data) ? data : Object.keys(data); 

            updateHiddenField(backingData, searchParameters, triggerChange);

            const optionsByValue = new Map();
            $.each(options, function ()
            {
                var option = $(this);
                option.prop("checked", false);
                optionsByValue.set(option.val(), option);
            });

            var list = $("#" + backingData.data("forId"));

            for (const searchParameter of searchParameters)
            {
                if (optionsByValue.has(searchParameter))
                {
                    optionsByValue.get(searchParameter).prop("checked", true);
                }
                else
                {
                    addCustomValue(list, this);
                }
            }
        };

        skyward.multipleselectbox.getValue = function (element)
        {
            return element.data().searchParameters.map(v => skyward.extensions.encodeHtml(v));
        };

        skyward.multipleselectbox.getOriginalValue = function (element)
        {
            return element.data().originalValue.map(v => skyward.extensions.encodeHtml(v));
        };

        skyward.multipleselectbox.clearValue = function (backingData, triggerChange)
        {
            skyward.multipleselectbox.populate(backingData, [], triggerChange);
        };

        var AddCustomClick = function ()
        {
            var jqThis = $(this);
            var list = $("#" + jqThis.data("forId"));
            var input = jqThis.prev();
            var userValue = input.val();

            addCustomValue(list, userValue);

            input.val("").focus();
        }

        var addCustomValue = function (list, value)
        {
            var template = list.find(".customValueTemplate");

            if (list.length && template.length && value)
            {
                var existingOptions = list.find(".multipleSelectOption input");
                for (var i = 0; i < existingOptions.length; i++)
                {
                    if ($(existingOptions[i]).val() == value)
                    {
                        return;
                    }
                }

                var newEntry = template.clone().removeClass("customValueTemplate").addClass("customValue");
                newEntry.find("input").val(value).prop("checked", true);
                newEntry.find("label").text(value);

                var hidden = list.find(".multiSelectBackingData");
                var hiddenData = hidden.data();
                var searchParameters = hiddenData.searchParameters;
                searchParameters.push(value);
                updateHiddenField(hidden, searchParameters, true);

                newEntry.appendTo(list).show().on("change", removeCustomValue);
            }
        };
        
        function removeCustomValue()
        {
            var jqThis = $(this);

            if (!jqThis.find(".checkbox").prop("checked"))
            {
                var valToRemove = jqThis.find(".multipleSelectOptionCheckbox").val();
                var nextCheckbox = jqThis.next(".multipleSelectOption:not(.customValueTemplate)");
                if (!nextCheckbox.length)
                {
                    nextCheckbox = jqThis.prev(".multipleSelectOption:not(.customValueTemplate)");
                }
                nextCheckbox.find("input").focus();

                var hidden = jqThis.parent(".multipleSelectBox").find(".multiSelectBackingData");
                var hiddenData = hidden.data();
                var searchParameters = hiddenData.searchParameters;
                searchParameters = searchParameters.filter(v => v != valToRemove);
                updateHiddenField(hidden, searchParameters);

                jqThis.remove();
            }
        };

        var updateHiddenField = function (hiddenInput, searchParameters, triggerChange)
        {
            hiddenInput.data("searchParameters", searchParameters);
            if (triggerChange)
            {
                hiddenInput.trigger("change");
            }
        };
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);